import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getLastSyncDate, sync, syncPatients, syncFiles } from './syncApi'

const initialState = {
    user: {
        id: null,
        isSyncing: false,
        lastSyncOn: null,
    },
    status: 'uninitialized',
}

export const getLastSync = createAsyncThunk('sync/get-last-sync', async (arg, thunkAPI) => {
    try {
        const response = await getLastSyncDate()
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const syncUser = createAsyncThunk('sync/user', async (arg, thunkAPI) => {
    try {
        const response = await sync()
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const syncPatient = createAsyncThunk('sync/patient', async (arg, thunkAPI) => {
    try {
        const response = await syncPatients()
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

export const syncSharedFiles = createAsyncThunk('app/sync-shared-files', async (arg, thunkAPI) => {
    try {
        const response = await syncFiles()
        return response.data
    } catch (error) {
        return thunkAPI.rejectWithValue(error)
    }
})

const syncSlice = createSlice({
    name: 'sync',
    initialState,
    reducers: {
        updateUserSync: (state, { payload }) => {
            state.user.isSyncing = payload.isSyncing
            if (payload.lastSync) {
                state.user.lastSyncOn = payload.lastSync
            }
        },
        updateSync: (state, { payload }) => {
            state.status = payload
        },
    },
    extraReducers: builder => {
        builder.addCase(syncPatient.pending, state => {
            state.user.isSyncing = true
        })
        builder.addCase(syncPatient.rejected, state => {
            state.user.isSyncing = false
        })
        builder.addCase(getLastSync.fulfilled, (state, { payload }) => {
            state.user.lastSyncOn = payload.data.updatedDateTime
        })
    },
})

export const { updateUserSync, updateSync } = syncSlice.actions
export default syncSlice.reducer
